import Vue from "vue";

const state = {
    isOnline: true,
    leaderChangeRequest:{
        time_utc:null
    }
}

const getters = {
    isOnline(state) {
        return state.isOnline;
    },
    hasLeaderChangeRequest(state){
        return (state.leaderChangeRequest && null!=state.leaderChangeRequest.time_utc);
    },
    leaderChangeRequest(state){
        return state.leaderChangeRequest
    }
}

const mutations = {
    SET_ONLINE_STATE(state, isConnected){
        state.isOnline = isConnected;
    },
    START_TEAMLEADER_CHANGE_REQUEST(state){
        Vue.set(state.leaderChangeRequest,'time_utc',new Date().getTime());
    },
    CLEAR_TEAMLEADER_CHANGE_REQUEST(state){
        Vue.set(state.leaderChangeRequest,'time_utc',null);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
};